import {
	createFileRoute,
	Link,
	Outlet,
	redirect,
	useRouterState,
} from "@tanstack/react-router";

export const Route = createFileRoute("/dev")({
	beforeLoad: () => {
		if (!import.meta.env.DEV) {
			throw redirect({
				to: "/",
				search: {
					mode: undefined,
					tag: undefined,
					type: undefined,
					summary: undefined,
				},
			});
		}
	},
	component: DevLayout,
});

function DevLayout() {
	const pathname = useRouterState({ select: (s) => s.location.pathname });

	// Individual prototypes get a full-page canvas with no chrome
	const isPrototype =
		pathname.startsWith("/dev/prototypes/") &&
		pathname !== "/dev/prototypes/";

	if (isPrototype) {
		return <Outlet />;
	}

	return (
		<div className="min-h-screen">
			<div className="border-line flex items-center gap-4 border-b px-6 py-2">
				<Link
					to="/dev"
					className="rounded bg-yellow-500 px-1.5 py-0.5 text-xs font-bold text-black no-underline select-none"
				>
					DEV
				</Link>
				<Link
					to="/dev/style-guide"
					className="text-muted hover:text-foreground [&.active]:text-foreground text-sm no-underline select-none"
					activeProps={{ className: "active" }}
				>
					Style Guide
				</Link>
				<Link
					to="/dev/prototypes"
					className="text-muted hover:text-foreground [&.active]:text-foreground text-sm no-underline select-none"
					activeProps={{ className: "active" }}
				>
					Prototypes
				</Link>
				<Link
					to="/dev/api-explorer"
					className="text-muted hover:text-foreground [&.active]:text-foreground text-sm no-underline select-none"
					activeProps={{ className: "active" }}
				>
					YouTube Scrape
				</Link>
				<Link
					to="/dev/chat-debug"
					search={{ thread: undefined }}
					className="text-muted hover:text-foreground [&.active]:text-foreground text-sm no-underline select-none"
					activeProps={{ className: "active" }}
				>
					Chat Debug
				</Link>
				<Link
					to="/dev/web-scrape"
					search={{
						key: undefined,
						view: "markdown",
						fullscreen: false,
					}}
					className="text-muted hover:text-foreground [&.active]:text-foreground text-sm no-underline select-none"
					activeProps={{ className: "active" }}
				>
					Web Scrape
				</Link>
			</div>
			<Outlet />
		</div>
	);
}
